import { render } from "./FormInputPlaintext.vue?vue&type=template&id=dcab1c60"
import script from "./FormInputPlaintext.vue?vue&type=script&lang=js"
export * from "./FormInputPlaintext.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__